import axios from "axios";
import {runQuery} from "../utils";
import {getRelatedExpressions} from "../TextCompareWrapper/queries.ts"


export const getCommunities = async (shortEid: string) => {
   // Fetch communities.json
   //const communitiesFileName = "./communities-2025-02-10.json"
   const communitiesFileName = "https://gist.githubusercontent.com/jeffreycwitt/87fea4d50fda32e64d9801b2b6010232/raw/communities.json"
   const data = await axios.get(communitiesFileName); // Await the Axios request

  // Find the second-level array that includes your id
    const result = data.data.find((subArray: []) => subArray.includes(shortEid));
    const sliceResult: [] = result?.slice(0, 20) || [];
    // const sliceResult: string[] = [
    //   "TAca84-d1e1324-d1e271", 
    //   // "lca8s8-d1e144-d1e1262",
    //   "jb2v19-d112347-d1e106",
    //   "Z4Yt34-d1e1156-d1e963",
    //   "TAca84-d1e1324-d1e297", 
    //   // "lca8s8-d1e276-d1e300",
    //   // "lca8s8-d1e763-d1e382",
    //   "act17_22"
    // ]
      // Always add shortEid and remove duplicates
    const uniqueSlicedResult = Array.from(new Set([shortEid, ...sliceResult]));

   const eids: string[] = uniqueSlicedResult.map((i: any) => {
     return "<http://scta.info/resource/" + i + ">";
   });
   
   const eidsString: string = eids.join(" ");
   return eidsString; // Return the resolved value

}

export const getTranscriptionIds = async (eidsString: string) => {
    const query: string = `
      SELECT ?transcriptionid ?authorTitle ?longTitle
      WHERE {
      VALUES ?eid { ${eidsString} }
      ?eid <http://scta.info/property/hasCanonicalManifestation> ?manifest .
      ?manifest <http://scta.info/property/hasCanonicalTranscription> ?transcriptionid .
      ?eid <http://scta.info/property/isPartOfTopLevelExpression> ?topLevelExpression .
      ?eid <http://scta.info/property/longTitle> ?longTitle .
      OPTIONAL{
        ?topLevelExpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .
        ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
      }
    }
    `
    const d = await runQuery(query); // Await the runQuery call
    const transcriptionids: string[] = d.data.results.bindings.map((i: any) => {
      return {
        id: i.transcriptionid.value, 
        longTitle: i.longTitle.value,
        authorTitle: i.authorTitle ? i.authorTitle.value : null, // Use optional chaining to avoid errors
      }
    });
    return transcriptionids; // Return the resolved value
}

export const getTranscriptionData = async (transcriptionids: {}) => {
  const requests = transcriptionids.map((item) =>
    axios.get(`https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=${item.id}`).then((res) => ({
      id: item.id, // Include the id
      longTitle: item.longTitle, // Include the long title
      authorTitle: item?.authorTitle || null, // Include the author title
      data: res.data, // Include the fetched data
    }))
  );
  // Wait for all requests to finish
  try {
    const responses = await Promise.all(requests);
    return responses // Return the data from all responses
  } catch (error) {
    console.error("Error fetching transcription data:", error);
    return []
  }
}

const getDirectRelations = async (shortEid: string) => {
  const d = await runQuery(getRelatedExpressions("http://scta.info/resource/" + shortEid, 0, 20, "", "")); // Await the runQuery call
  const expressionList = ["<http://scta.info/resource/" + shortEid + ">"]
  d.data.results.bindings.forEach((item: any) => {
    expressionList.push("<" + item.isRelatedTo.value + ">");
  })

  return expressionList.join(" ");
}


// Wrapper function
export const getTranscriptions = async (shortEid: string): Promise<{}> => {
  try {
    // switch between getCommunities and getDirectRelations
    const eidsString = await getCommunities(shortEid); // Step 1: Get communities
    //const eidsString = await getDirectRelations(shortEid); // Step 1: Get direct relations
    
    const transcriptionids = await getTranscriptionIds(eidsString); // Step 2: Get transcription IDs
    const transcriptions = await getTranscriptionData(transcriptionids); // Step 3: Get transcription data
    const transcriptionsObject = transcriptions.reduce((acc, item) => {
      acc[item.id] = {
        text: item.data,
        longTitle: item.longTitle,
        authorTitle: item?.authorTitle || null, // Use optional chaining to avoid errors
      }; // Set the id as the key and data as the value
      return acc;
    }, {});
    return transcriptionsObject; // Return the final transcription data
  } catch (error) {
    console.error("Error in getTranscriptions:", error);
    throw error; // Rethrow the error for the caller to handle
  }
};

// const eidsString = await getCommunities(); // Await the result of getCommunities()
// const transcriptionids = await getTranscriptionIds(eidsString); // Await the result of getCommunities()
// const transcriptions = await getTranscriptionData(transcriptionids); // Await the result of getTranscriptionData()

